// TODO: Add unit tests

export function initDigitalMatter(hasConsentedTargeting: boolean) {
  if (!hasConsentedTargeting) return

  window.dimatter = window.dimatter || []
  window.dimatter.push('standalone')
  window.dimatter.push(['_initialize'])
}
